module.exports = __webpack_public_path__ + "static/media/2021_cadillac_ct5_ext_03_6DC79_1SD_GJI.4238a410.png";